import { Field } from 'formik';
import { FieldProps } from 'formik/dist/Field';
import { ReactNode } from 'react';
import ReactSwitch, { ReactSwitchProps } from 'react-switch';
import { theme } from '../../../../styles';

interface Props extends ReactSwitchProps {
  readonly size?: 'sm' | 'md' | 'lg';
  readonly disabled?: boolean;
  readonly onColor?: string;
  readonly offColor?: string;
  readonly label?: ReactNode;
  readonly style?: React.CSSProperties;
}

function getDimensions(size: Props['size']) {
  switch (size) {
    case 'lg':
      return {};
    case 'md':
      return {
        width: 42,
        height: 22,
      };
    case 'sm':
      return {
        width: 34,
        height: 16,
      };
    default:
      return {
        width: 42,
        height: 22,
      };
  }
}

export const SwitchInput = (p: Props) => {
  const { onColor, offColor, size, label, style, ...rest } = p;

  return (
    <label className="d-inline-flex align-content-center" style={{ ...style, cursor: 'pointer' }}>
      <ReactSwitch
        className="__switch"
        onColor={onColor || theme.green}
        offColor={offColor || theme.red}
        {...getDimensions(size)}
        {...rest}
      />
      {label && <div className={`ml-2 ${size === 'sm' && 'font-size-sm'}`}>{label}</div>}
    </label>
  );
};

SwitchInput.defaultProps = {
  size: 'md',
};

export function SwitchField(props: Omit<Props, 'checked' | 'onChange'> & { name: string }) {
  const { name, ...rest } = props;
  return (
    <Field name={name}>
      {(fp: FieldProps) => {
        return (
          <SwitchInput
            {...rest}
            checked={fp.field.value}
            onChange={(checked) => {
              fp.form.setFieldValue(name, checked);
            }}
            //error={fp.meta.touched && fp.meta.error}
          />
        );
      }}
    </Field>
  );
}
